import React, { useState, useEffect, useContext } from 'react';
import { createContext } from 'react';
import { FullPageLoader } from '../components/loaders/FullPageLoader';
import { axiosClient } from '../libs/axios';

const Context = createContext(null);

export const useRestaurant = () => useContext(Context);

export const RestaurantProvider = React.memo(({ children }) => {
    const [state, setState] = useState(null);

    useEffect(() => {
        const abortController = new AbortController();

        axiosClient.get(`/api/restaurant/${window.vendor}`, { signal: abortController.signal })
            .then(response => {
                setState(response.data)
            })
        
        return () => {
            abortController.abort();
        };
    }, []);
    
    if (!state) {
        return (
            <FullPageLoader />
        );
    }
    
    return (
        <Context.Provider value={state}>
            {children}
        </Context.Provider>
    );
});
